"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OptionalMessage = void 0;
var PropTypes = require("prop-types");
var React = require("react");
var OptionalMessage = function (props) {
    var message = props.message;
    var optionalText = message ? message : ' (optional)';
    return (React.createElement("span", { className: "form-label-text-secondary" }, optionalText));
};
exports.OptionalMessage = OptionalMessage;
exports.OptionalMessage.propTypes = {
    message: PropTypes.string,
};
